module.exports = __webpack_public_path__ + "static/media/af.fa735e43.svg";